var _ = require('lodash');

var compositesDefinition = require('./compositeDefinitions');

var compositeFactory = require('./compositeFactory');

var Composites = _.mapValues(compositesDefinition.AllCompositeDefinitions, function (v) {
  return compositeFactory(v);
});

module.exports = Composites;